if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.submitButton = this.querySelector('[type="submit"]');

        this.header = document.querySelector('.header-wrapper');
        this.announcementBar = document.querySelector('.announcement-bar');

        const mediaQuery = window.matchMedia('(min-width: 750px)');
        mediaQuery.addEventListener('change', (e) => {
          this.isScrollListenerActive = e.matches
          this.onWindowScroll();
        });
        this.isScrollListenerActive = mediaQuery.matches;

        this.onWindowScroll();
        window.addEventListener('scroll', () => window.requestAnimationFrame(this.onWindowScroll.bind(this)));
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      lastScrollPosition = 0;

      onWindowScroll() {
        const isScrollingDown = window.scrollY > this.lastScrollPosition;
        this.lastScrollPosition = window.scrollY;

        const rect = this.getBoundingClientRect();

        const headerHeightStr = window.getComputedStyle(document.documentElement).getPropertyValue('--header-height');
        const headerHeight = parseInt(headerHeightStr.substring(0, headerHeightStr.length - 2));

        const defaultTopOffset = 30 + headerHeight * 1.5;
        const defaultTopOffsetStr = defaultTopOffset + 'px';
        const maxTopOffset = this.parentElement.getBoundingClientRect().height - rect.height;

        if (!this.isScrollListenerActive) {
          this.style.position = '';
          this.style.top = '';
          return;
        }

        if (rect.height < window.innerHeight - defaultTopOffset - (this.announcementBar?.offsetHeight ?? 0)) {
          this.style.position = 'sticky';
          this.style.top = defaultTopOffsetStr;
          return;
        }

        if (this.style.position === '' || this.style.top === '') {
          this.style.position = 'sticky';
          this.style.top = defaultTopOffsetStr;
        } else {
          if (isScrollingDown) {
            if (this.style.position === 'sticky' && rect.bottom > window.innerHeight - 31) {
              this.style.top = Math.max(0, Math.min(maxTopOffset, Math.round(window.scrollY + rect.top - defaultTopOffset - (this.announcementBar?.offsetHeight ?? 0)))) + 'px';
              this.style.position = 'relative';
            } else if (this.style.position === 'relative' && rect.bottom <= window.innerHeight - 32) {
              this.style.top = window.innerHeight - rect.height - 32 + 'px';
              this.style.position = 'sticky';
            }
          } else {
            if (this.style.position === 'sticky' && rect.top < defaultTopOffset) {
              this.style.top = Math.max(0, Math.min(maxTopOffset, Math.round(window.scrollY + rect.top - defaultTopOffset - (this.announcementBar?.offsetHeight ?? 0)))) + 'px';
              this.style.position = 'relative';
            } else if (this.style.position === 'relative' && rect.top >= defaultTopOffset) {
              this.style.top = defaultTopOffsetStr;
              this.style.position = 'sticky';
            }
          }
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
    }
  );
}

if (!customElements.get('premium-badge')) {
  customElements.define(
    'premium-badge',
    class PremiumBadge extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.premiumSection = document.getElementById('section-widget-premium');

        if(!this.premiumSection) return;

        this.badge = this.querySelector('.product__premium-badge');

        this.tabIndex = parseInt(this.getAttribute('data-tab-index'));

        this.badge.addEventListener('click', () => {
          const tabBtn = this.premiumSection.querySelector(`.widget-premium__tab-btn[data-index="${this.tabIndex}"]`);
          if(!tabBtn) return;

          tabBtn.click();
        });
      }
    }
  );
}